// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1af94a97","488":"fe5ed274","977":"222fad4c"}[chunkId] + ".chunk.js";
};